<template>
  <div class="con-wrap">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label name></el-tab-pane>
      <el-tab-pane label="手机FAQ管理" name="1"></el-tab-pane>
      <el-tab-pane label="车机FAQ管理" name="2"></el-tab-pane>
    </el-tabs>
    <div class="con">
      <el-form
        size="medium"
        :inline="true"
        ref="queryForm"
        class="input-form-inline"
      >
        <div style="margin-bottom:20px">
          <el-button
            v-if="hasPerm('often:issue:save')"
            type="primary"
            @click="addProblem"
            >新增</el-button
          >
          <el-button
            v-if="hasPerm('often:issue:update')"
            type="primary"
            @click="editProblem"
            >修改</el-button
          >
          <el-button
            size="medium"
            v-if="hasPerm('often:issue:delete')"
            type="danger"
            @click="delProblem"
            >删除</el-button
          >
        </div>
      </el-form>
      <div class="coll-Box">
        <el-collapse v-model="collActiveName" accordion>
          <el-collapse-item
            v-for="item in tableData"
            :title="item.content"
            :name="item.id"
            :key="item.id"
            class="collapse-box"
          >
            <div>
              {{ item.method }}
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <!-- 新增 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="problem-dialog"
    >
      <el-form
        :rules="Rules"
        ref="problemForm"
        :model="problemForm"
        size="mini"
        :inline="true"
      >
        <el-form-item prop="content" label="问题内容">
          <el-input
            v-model="problemForm.content"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item prop="method" label="问题解答">
          <el-input
            type="textarea"
            v-model="problemForm.method"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Rules: {
        content: [
          {
            required: true,
            trigger: "change",
            message: "请输入问题内容",
          },
        ],
        method: [
          {
            required: true,
            trigger: "change",
            message: "请输入问题解答",
          },
        ],
      },
      collActiveName: "1",
      activeName: "1",
      dialogTitle: "新增常见问题",
      dialogVisible: false,
      problemForm: {},
      editTag: "",
      tableData: [],
    };
  },
  created() {
    this.getProblemList();
  },
  watch: {
    activeName(val) {
      let _this = this;
      if (val) {
        this.$nextTick(() => {
          _this.getProblemList();
        });
      }
    },
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    async getProblemList() {
      let obj = {};
      obj.type = parseInt(this.activeName);
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/often/issue/list", {
        params: obj,
      });
      if (res.code == 1) {
        _this.tableData = res.data;
        _this.collActiveName = _this.tableData[0].id;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    addProblem() {
      this.editTag = "0";
      //清空表单数据
      this.$resetForm(this, "problemForm");
      //设置弹框标题
      this.dialogTitle = "新增常见问题";
      //显示弹框
      this.dialogVisible = true;
    },
    editProblem() {
      if (this.collActiveName == "") {
        this.$message.warning("请先选择数据");
        return;
      }
      this.getProblemInfo(this.collActiveName);
      this.editTag = "1";
      //清空表单数据
      this.$resetForm(this, "problemForm");
      //设置弹框标题
      this.dialogTitle = "修改常见问题";
      // this.problemForm.id = this.activeName
      //显示弹框
      this.dialogVisible = true;
    },
    async getProblemInfo(id) {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/often/issue/info/" + id);
      if (res.code == 1) {
        _this.problemForm = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async delProblem() {
      if (this.collActiveName == "") {
        this.$message.warning("请先选择数据");
        return;
      }
      let _this = this;
      let ids = [];
      ids.push(this.collActiveName);
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete("/api/often/issue", {
            data: JSON.stringify(ids),
          });
          if (res.code == 1) {
            _this.$message.success("操作成功");
            _this.getProblemList();
          } else {
            _this.$message.warning(res.msg);
          }
        });
    },
    saveOrUpdate() {
      let _this = this;
      let data = [];
      _this.problemForm.type = parseInt(this.activeName);
      _this.$refs.problemForm.validate(async (valid) => {
        if (valid) {
          if (_this.editTag == "0") {
            data = await _this.$axios.post(
              "/api/often/issue",
              _this.problemForm
            );
          } else {
            data = await _this.$axios.patch(
              "/api/often/issue",
              _this.problemForm
            );
          }
          let res = data.data;
          if (res.code == 1) {
            _this.dialogVisible = false;
            _this.$resetForm(_this, "problemForm");
            _this.getProblemList();
            _this.$message.success("操作成功");
          } else {
            _this.$message.warning(res.msg);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.collapse-box /deep/ {
  .el-collapse-item__header {
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    border-bottom: 2px solid #fff;
    background: #f2f2f2;
    color: #333;
    font-size: 14px;
  }
  .el-collapse-item__content {
    padding-top: 10px;
    padding-left: 20px;
    font-size: 14px;
    color: #333;
  }
  .el-collapse-item__header.is-active {
    background: #a4d5f9;
  }
}
.problem-dialog /deep/ .el-dialog {
  width: 620px;
}
.problem-dialog /deep/ .el-form-item__label {
  width: 160px;
  height: 32px;
  margin-left: 20px;
  text-align: left;
  color: #343434;
  font-size: 14px;
}
.problem-dialog /deep/ .el-form-item__content {
  width: 380px;
  height: auto;
  .el-textarea{
    textarea{
      min-height: 100px !important;
    }
  }
}
.con-wrap /deep/ {
  .el-tabs #tab-0 {
    padding: 0;
    height: 0;
  }
  .el-tabs .el-tabs__header {
    background: #fff;
    margin-bottom: 20px;
  }
  .coll-Box {
    max-height: 560px;
    overflow: auto;
  }
}
.con {
  height: calc(100% - 60px);
  padding: 0 20px;
  background: #fff;
  overflow-y: auto;
}
</style>
